<template>
  <div class="row">
    <div class="col-lg-8">
    	<card>
			<h2>Per modificare la tua firma, compila la parte sottostante</h2>
			<div class="only-portrait">
				<div class="turn-hing py-6">
					<h3>Gira il telefono</h3>
				</div>
			</div>
			<VueSignaturePad
				class="signature-container only-landscape"
				width="607px"
				save-type="image/svg+xml"
				height="230px"
				ref="signaturePad"
			/>
			<base-button
				type="info"
				@click="save()"
				>
				Aggiorna firma
			</base-button>
    	</card>
    </div>
    <div class="col-lg-4"><user-card> </user-card></div>
  </div>
</template>
<script>
	import { mapState, mapActions } from 'vuex'
	import UserCard from './UserProfile/UserCard.vue';
	import VueSignaturePad from 'vue-signature-pad';

	export default {
		computed: {
			...mapState({
				account: state => state.account,
			})
		},
	  	components: {
	  		VueSignaturePad,
	    	UserCard
	  	},
	  	mounted(){
	  		this.get()
	  	},
	  	methods: { 
			...mapActions('users', {
				update: 'update',
			}),
			...mapActions('account', {
				get: 'fetchFromServer',
			}),
			save() {
				const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
				if (!isEmpty){ // TODO VALIDAZIONE FIRMA
					// this.account.user.id = this.account.user._id;
					this.account.user.signature = data;
					this.update(this.account.user)
				}
			},
		}
	};
</script>
<style lang="scss">
	.turn-hing{
		background: #ddd;
		padding: 60px 0;
		h3{
			font-weight: bold;
			color:#666;
			text-align: center;
			margin: 0;
		}
	}
	.only-portrait{
		display: none;
		@media only screen and (orientation : portrait) and (max-width : 767px){
			display: block;
		}
	}
	.only-landscape{
		display: block;
		@media (orientation : portrait){
			display: none;
		}
		@media (min-width: 768px){
			display: block !important;
		}
	}
	
	.signature-container{
		background: #ddd;
	}
</style>
